// Global Instructions Rule Applied!
import { validateTaskRecord, TaskRecordFields } from '../../../state_manager/data_models/task_record.ts'

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'

/**
 * Reorder tasks
 */
export const reorderTasks = async (
  dealId: string,
  taskOrders: Array<{ id: string; sort_order: number }>,
  accessToken: string | null = null
): Promise<void> => {
  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    }

    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`
    }

    const response = await fetch(`${BACKEND_BASE_URL}/deals/${dealId}/tasks/reorder`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(taskOrders)
    })

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Authentication failed - please log in again')
      }
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to reorder tasks')
    }

    const data = await response.json()

    if (!data.success) {
      throw new Error(data.error || data.message || 'Failed to reorder tasks')
    }
  } catch (error) {
    console.error('Error reordering tasks:', error)
    throw error
  }
}
